<template>
  <section class="section-two bg-light mt-5 mb-2">
    <div class="container-fluid">

      <div class="row justify-content-center">
        <div class="col-lg-10">
          <div class="row">
            <div class="col-8">
              <p class="h4">
                <b>Escolha {{isExam ? 'o tipo' : 'a área'}}</b>
              </p>
            </div>
            <div class="col-4 mb-3 text-end">
              <button type="button" class="btn btn-outline-primary btn-sm"
                      @click="$router.back()">
                <i class="fa fa-arrow-left"></i> Voltar
              </button>
            </div>
          </div>

          <div class="mb-4">
            <div class="form-icon position-relative">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                   class="feather feather-search fea icon-sm icons">
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
              </svg>
              <input name="insurance" id="insurance" class="form-control ps-5" placeholder="Pesquisar área ou especialidade" v-model="search">
            </div>
          </div>

          <div class="card shadow rounded border-0 mb-3 pricing-rates business-rate"
               @click="selectGroup(type)"
               style="cursor: pointer;" v-for="type in groups" :title="'Agendar ' + type.spec_group_name">
            <div class="m-3">
              <b class="h5 text-primary">{{type.spec_group_name}}</b>
              <i class="ms-1 fas fa-1x fa-arrow-circle-right text-primary"></i>
              <p class="text-muted mb-0">{{type.spec_group_description}}</p>
            </div>
          </div>

        </div>
      </div>
    </div>
  </section>
</template>

<script>
import http from "@/helpers/http";
import MenuAction from "@/views/toSchedule/MenuAction.vue";

export default {
  name: 'SpecGroup',
  components: {MenuAction},
  data() {
    return {
      search: '',
      groupsList: [],
    }
  },
  mounted() {
    this.getGroups();
  },
  computed: {
    isExam() {
      return this.$store.state.toSchedule.attendanceType.substring(0, 4) === 'EXAM';
    },
    groups() {
      if (this.search === '')
        return this.groupsList;

      return this.groupsList.filter(group => {
        let strFilter = JSON.stringify(group);
        return strFilter.toLowerCase().includes(this.search.toLowerCase())
      });
    },
  },
  methods: {
    getGroups() {
      http.get(`/schedule/specialty-groups`, {
        params: {
          id_city: this.$store.state.toSchedule.schedule.city?.id_city,
          id_place: this.$store.state.toSchedule.place?.id_place,
          spec_group_mode: this.$route.query.mode,
          spec_group_type: this.$route.query.type,
          kind_exam: this.$route.query.type === 'exam',
          kind_procedure: this.$route.query.type === 'procedure',
          id_exam_type: this.$route.query.id_exam_type,
        }
      }).then((response) => {
        this.groupsList = response.data;
      });
    },
    selectGroup(group) {
      this.$store.commit('toSchedule/setSpecGroup', {
        id_spec_group: group.id_spec_group,
        spec_group_name: group.spec_group_name,
      });

      this.$router.push('/specialties')
    },
  }
}
</script>

<style scoped>

</style>
